import { empty } from "../GangsPage/style.css.ts";
import butt from "./butt.png";
import dumb from "./dumb.png";

const images = {
  dumb,
  butt,
};

export function EmptyState(props: {
  image: keyof typeof images;
  message: string;
}) {
  const { image, message } = props;

  return (
    <div className={empty.container}>
      <img src={images[image]} alt="" className={empty.image} />
      <div className={empty.text}>{message}</div>
    </div>
  );
}
